<template>
	<div class="hour-picker-wrapper">
		<label v-if="label" class="hour-label">{{ label }}</label>
		<div class="hour-picker">
			<input
				type="text"
				class="hour-input"
				v-model="hour"
				@input="validateHour"
				@blur="formatHour"
				maxlength="2"
			/>
			<span class="separator">:</span>
			<input
				type="text"
				class="minute-input"
				v-model="minute"
				@input="validateMinute"
				@blur="formatMinute"
				maxlength="2"
			/>
			<div class="icon">
				<i class="fa-regular fa-clock" />
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref, watch, defineProps, defineEmits } from 'vue'

	const props = defineProps({
		modelValue: {
			type: String,
			default: '10:00',
		},
		label: {
			type: String,
			default: '',
		},
	})

	const emit = defineEmits(['update:modelValue', 'change'])

	const [initialHour, initialMinute] = props.modelValue.split(':')

	const hour = ref(initialHour || '00')
	const minute = ref(initialMinute || '00')

	watch([hour, minute], () => {
		const value = `${hour.value.padStart(2, '0')}:${minute.value.padStart(2, '0')}`
		emit('update:modelValue', value)
		emit('change', value)
	})

	function validateHour() {
		const val = parseInt(hour.value)
		if (isNaN(val) || val < 0) hour.value = '00'
		else if (val > 23) hour.value = '23'
	}

	function validateMinute() {
		const val = parseInt(minute.value)
		if (isNaN(val) || val < 0) minute.value = '00'
		else if (val > 59) minute.value = '59'
	}

	function formatHour() {
		hour.value = hour.value.padStart(2, '0')
	}

	function formatMinute() {
		minute.value = minute.value.padStart(2, '0')
	}
</script>

<style scoped lang="stylus">
@import './styles.styl'
</style>
